import moment from 'moment';

import ApiService from 'services/ApiService/ApiService';
import CookieStorageService from 'services/CookieStorageService';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';
import { isMyProfileHelperFunc } from 'utils/helpers';
import {
  GET_ENCRYPTED_USERNAMES_URL,
  GET_LOVENSE_DATA_URL_BASE,
  PLATFORM,
} from 'utils/lovense/lovenseUtils';


export const getEncryptedUserName = (params, data) => {
  ApiService.post(GET_ENCRYPTED_USERNAMES_URL, { params, data })
    .then(
      (res) => {
        const viewerEncKey = res.data.encryptedUsername;
        const performerEncKey = res.data.encryptedRoomName;
        window.Lovense.init(PLATFORM, performerEncKey, viewerEncKey);
      }
    );
};

export const getLovenseDataHandler = (params, kcid) => {
  const url = `${GET_LOVENSE_DATA_URL_BASE}/${kcid}`;
  ApiService.get(url, { params })
    .then((res) => {
      window.Lovense.recieveData(res.data);
    });
};

export const isAvailableToChangeLovense = () => window.Lovense && UserStore.hasCF(allUserGroups.KIIROO_CONTROL);

export const broadcasterAsViewer = (user, profileName) => UserStore.hasCF(
  allUserGroups.BROADCASTER_AS_VIEWER)
  && isMyProfileHelperFunc(user, profileName);

export const setCookie = () => {
  const nextDay = moment().add(1, 'days').toDate();
  CookieStorageService.set('cam4_hide_promo_overlay', 'invisible', { path: '/', expires: nextDay });
};
